import { Component, Input } from '@angular/core';
import { KnowledgeBaseItemInterface } from '@app/core/interfaces/knowledge-base-item.interface';

@Component({
    selector: 'ins-seo-page-header',
    templateUrl: './seo-page-header.component.html',
    styleUrls: ['./seo-page-header.component.scss'],
})
export class SeoPageHeaderComponent {
    @Input() knowledgeBaseItem: KnowledgeBaseItemInterface;
}
